import warningGeneral from "../../assets/warningGeneral.png";
import Button from "../../Components/Button";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";

function CancelReimbursementModal(props) {
  const { open, onClose, onCancel } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex items-center justify-center">
          <img src={warningGeneral} alt="error icon" width="60px" />
        </div>

        <div className="text-center font-semibold mt-1">
          Cancel reimbursement request
        </div>

        <div className="my-2 text-center">
          Are you sure you want to cancel your reimbursement request?
        </div>

        <div className="mt-2">
          <Button className="w-full text-white" onClick={onClose}>
            Continue
          </Button>
        </div>
        <div className="mt-2">
          <Button className="w-full bg-white border" onClick={onCancel}>
            Cancel request
          </Button>
        </div>
      </div>
    </Modal>
  );
}

CancelReimbursementModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
};

export default CancelReimbursementModal;
